import { render, staticRenderFns } from "./SpeedLimitByZone.vue?vue&type=template&id=72b18745&"
import script from "./SpeedLimitByZone.vue?vue&type=script&lang=js&"
export * from "./SpeedLimitByZone.vue?vue&type=script&lang=js&"
import style0 from "./SpeedLimitByZone.vue?vue&type=style&index=0&id=72b18745&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports